import { Box, Button, Stack } from '@chakra-ui/react';
import { useEffect, useRef, useState } from 'react';
import { ContractRenderer } from './ContractRenderer';

interface Props {
  snapshot: any;
  onContinue: () => void;
}

const MIN_READ_MS = 5000;

export function ContractStepRead({ snapshot, onContinue }: Props) {
  const [scrolledBottom, setScrolledBottom] = useState(false);
  const [minTimePassed, setMinTimePassed] = useState(false);
  const scrollBoxRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const t = setTimeout(() => setMinTimePassed(true), MIN_READ_MS);
    return () => clearTimeout(t);
  }, []);

  useEffect(() => {
    const el = scrollBoxRef.current;
    if (!el) return;
    const onScroll = () => {
      const atBottom = el.scrollTop + el.clientHeight >= el.scrollHeight - 8;
      if (atBottom) setScrolledBottom(true);
    };
    el.addEventListener('scroll', onScroll);
    // Trigger once to handle short contracts that don't need scrolling
    onScroll();
    return () => el.removeEventListener('scroll', onScroll);
  }, []);

  const canContinue = scrolledBottom && minTimePassed;

  return (
    <Stack spacing={4}>
      <Box ref={scrollBoxRef} maxH="60vh" overflowY="auto" border="1px solid" borderColor="gray.200" borderRadius="md" p={4}>
        <ContractRenderer snapshot={snapshot} />
      </Box>
      <Button colorScheme="blue" isDisabled={!canContinue} onClick={onContinue}>
        {canContinue ? 'Continuar' : minTimePassed ? 'Role até o fim para continuar' : 'Aguarde...'}
      </Button>
    </Stack>
  );
}
